import { ActionItem, Icon } from '@factorialco/deprecated-design-system'
import filter from 'lodash/filter'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import InlineSearch from 'modules/core/components/InlineSearch'
import Logo from 'modules/core/components/Logo'
import useSearch from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import type Company from 'modules/core/store/models/Company'
import app from 'modules/core/store/models/app'

import * as styles from './index.vanilla.css'

interface Props {
  onChoose: () => void
  isFullPage?: boolean
}

function CompanySelector({ onChoose, isFullPage = false }: Props) {
  const showSelected = !isFullPage
  const showIcon = !isFullPage
  const boxStyle = isFullPage ? styles.companies_full_page : styles.companies
  const { search, onSearch } = useSearch()

  const onClick = (company: Company) => {
    return async () => {
      try {
        await company.rpc('select_current')
        await companies.fetch()
        onChoose()
      } catch (error) {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('common.forbidden'),
        })
      }
    }
  }

  const renderCompany = (company: Company) => {
    const isCurrent = company === companies.selected && showSelected

    return (
      <ActionItem
        key={company.attributes.id}
        onClick={isCurrent ? null : onClick(company)}
        selected={isCurrent}
        showIcon={showIcon}
      >
        <div tabIndex={0} className={styles.company}>
          <div className={styles.companyLogo}>
            <Logo
              companyLogo={company.attributes.logo}
              alt={company.attributes.name}
              width={80}
              height={25}
            />
          </div>
          <div className={styles.companyName}>{company.attributes.name}</div>
          {isCurrent && (
            <div className={styles.companyCheck}>
              <Icon.Medium icon="check" color="viridian1000" />
            </div>
          )}
        </div>
      </ActionItem>
    )
  }

  const filteredCompanies = filter(companies.models, (company) => company.matchesName(search))

  return (
    <div className={boxStyle}>
      <BoxList>
        {companies.models.length > 3 && <InlineSearch search={search} onSearch={onSearch} />}
        {filteredCompanies.map(renderCompany)}
      </BoxList>
    </div>
  )
}

export default observer(CompanySelector)
